import React, { useContext, useEffect, useState } from "react";

import { Button } from "antd";

import { AppContext } from "../AppContext";

import { signOut } from "../utils/common";

import logout from "../actions/logout";

import maintenanceImg from "../assets/images/under_maintenance.gif";

import "./AuthFailedPage.css";

const AuthFailedPage = ({ history }) => {
  const [timeRemaining, setTimeRemaining] = useState(10);
  const appContext = useContext(AppContext);

  /**
   * Set countdown timer.
   */
  useEffect(() => {
    if (!timeRemaining) {
      // Call logout API first before clearing credentials
      // Use async IIFE to properly await logout
      (async () => {
        try {
          await logout();
        } catch (error) {
          // Silently handle any errors - frontend logout proceeds regardless
        } finally {
          // Always call signOut regardless of logout API success/failure
          signOut(history, appContext);
        }
      })();
      return;
    }
    const intervalID = setInterval(() => setTimeRemaining(timeRemaining - 1), 1000);

    return () => clearInterval(intervalID); // eslint-disable-line
  }, [timeRemaining, history, appContext]); // eslint-disable-line

  return (
    <div className="AuthFailedPage">
      <img src={maintenanceImg} alt="under_maintenance" width={450} />
      <span className="AuthFailedPage__Header">{`Signing out in ${timeRemaining}s`}</span>
      <span className="AuthFailedPage__SubHeader">Authentication failed.</span>
      <Button
        type="primary"
        className="AuthFailedPage__SignOutButton"
        onClick={async () => {
          // Call logout API first before clearing credentials
          await logout()
            .catch(() => {
              // Silently handle any errors - frontend logout proceeds regardless
            })
            .finally(() => {
              // Always call signOut regardless of logout API success/failure
              signOut(history, appContext);
            });
        }}
      >
        Sign Out
      </Button>
    </div>
  );
};

export default AuthFailedPage;
